import { useContext, useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import CentersList from './components/form/CentersList'
import Header from './components/form/Header'
import Login from './components/form/Login'
import PrivateRoute from './components/form/PrivateRoute'
import UpdateCenter from './components/form/UpdateCenter'
import ViewCenter from './components/form/ViewCenter'
import Map from './components/map/Map'
import { Context } from './contexts/Context'
import { getCookie } from './services/form/cookies'

export default function App () {
  let { token } = useContext(Context)
  const localToken = getCookie('fmtaccount')
  token = token || localToken
  const [currentLocation, setcurrentLocation] = useState(null)
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude: lat, longitude: lng } }) => {
        const location = { lat, lng }
        setcurrentLocation(location)
      })
  }, [])

  return (
    <>
      <Routes>
        <Route
          path='/'
          element={
            <Map />
          }
        />
        <Route
          path='/login'
          element={
            <>
              <Header token={token} /> <Login token={token} />
            </>
          }
        />

        <Route
          path='/centers'
          element={
            <>
              <PrivateRoute>
                <Header token={token} /> <CentersList token={token} currentLocation={currentLocation} />
              </PrivateRoute>
            </>
          }
        />

        <Route
          path='/center/:id' element={
            <>
              <PrivateRoute>
                <Header token={token} /> <ViewCenter token={token} />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path='/center/:id/edit'
          element={
            <PrivateRoute>
              <Header token={token} /> <UpdateCenter props={{ currentLocation, token }} />
            </PrivateRoute>
          }
        />
        <Route path='*' element={<Map />} />
      </Routes>
    </>
  )
}
